interface FsElement extends HTMLElement {
  webkitRequestFullscreen?: () => Promise<void> | void
}
interface FsDocument extends Document {
  webkitFullscreenElement?: Element | null
  webkitExitFullscreen?: () => Promise<void> | void
}

export function isFullscreen(): boolean {
  const d = document as FsDocument
  return !!(document.fullscreenElement || d.webkitFullscreenElement)
}

export function fullscreenSupported(): boolean {
  const el = document.documentElement as FsElement
  return !!(el.requestFullscreen || el.webkitRequestFullscreen)
}

export async function enterFullscreen(): Promise<void> {
  if (isFullscreen()) return
  const el = document.documentElement as FsElement
  try {
    if (el.requestFullscreen) await el.requestFullscreen()
    else if (el.webkitRequestFullscreen) await el.webkitRequestFullscreen()
  } catch {
    /* user gesture / permission constraints — ignore */
  }
}

export async function exitFullscreen(): Promise<void> {
  if (!isFullscreen()) return
  const d = document as FsDocument
  try {
    if (document.exitFullscreen) await document.exitFullscreen()
    else if (d.webkitExitFullscreen) await d.webkitExitFullscreen()
  } catch {
    /* ignore */
  }
}
